import React, { Component } from "react";
import { Accordion } from '@material-ui/core'
import { AccordionSummary } from '@material-ui/core'
import { ExpansionPanelDetails } from '@material-ui/core';
import { List, ListSubheader, ListItem, ListItemIcon, ListItemText, Collapse } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { Link } from "react-router-dom";
import './MenuLeftNav.css';
import { fas } from '@fortawesome/free-solid-svg-icons'
import * as auth from "../../store/ducks/auth.duck";
import { connect } from "react-redux";
import { checkModulePermission } from "../../crud/auth.crud";


library.add(fas)

class MenuLeftNav extends Component {
    constructor(props) {
        super(props);
        // Don't call this.setState() here!
        this.state = {
            expanded: false,
            activeClass: '',
            show: false,
            userModuleAccessList: [],
            showListMenuMobile: false,
        };

    }
    componentDidMount() {
        if (this.props.isExpand.expand) {
            this.setState({ expanded: this.props.isExpand.expand, activeClass: this.props.isExpand.active });
        }
    }
    handleChange = (panel) => (event) => {
        panel ? this.setState({ expanded: panel, activeClass: panel }) : this.setState({ expanded: false });
    };
    render() {
        var showlistMenuClass = this.state.showListMenuMobile ? 'setting-menu showlist-menu' : 'setting-menu hidelist-menu';
        return (
            <>
            <div className="users-menu">
                {!this.state.showListMenuMobile ? <FontAwesomeIcon onClick={() => {this.setState({showListMenuMobile: !this.state.showListMenuMobile})}}  icon={["fas", "bars"]} size="xs" color="#bcbccf" style={{cursor: 'pointer'}} /> : <FontAwesomeIcon onClick={() => {this.setState({showListMenuMobile: !this.state.showListMenuMobile})}}  icon={["fas", "times"]} size="xs" color="#bcbccf" style={{cursor: 'pointer'}} /> }
            </div>
            <div className={showlistMenuClass}>
                <List
                    component="ul"
                    aria-labelledby="setting-list"
                    subheader={
                        <ListSubheader component="div" id="setting-list">
                            Settings
                        </ListSubheader>
                    }
                >
                    {checkModulePermission('list-users-limited') === true ?
                        <>
                            <ListItem component="li" button onClick={this.handleChange(this.state.expanded === "user" ? false : "user")} className={(this.state.activeClass === "user" || this.state.activeClass === "adduser") ? 'active' : ''} >
                                <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon> <ListItemText primary="Users" />
                                {this.state.expanded === "user" ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>

                            <Collapse component="div" in={this.state.expanded === "user"} timeout="auto" unmountOnExit>
                                <List component="ul" disablePadding>
                                    <ListItem button component="li" className={(this.state.activeClass === "user") ? 'active' : ''}>
                                        <Link to="/users"> <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon>Users</Link>
                                    </ListItem>
                                    {checkModulePermission('add-user') === true &&
                                        <ListItem button component="li" className={(this.state.activeClass === "adduser") ? 'active' : ''}>
                                            <Link to="/user/create"> <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon>Add User</Link>
                                        </ListItem>
                                    }
                                </List>
                            </Collapse>
                        </>


                        :
                        <>
                            {checkModulePermission('list-users') === true &&
                                <ListItem component="li" button onClick={this.handleChange(this.state.expanded === "user" ? false : "user")} className={(this.state.activeClass === "user" || this.state.activeClass === "adduser") ? 'active' : ''} >
                                    <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon> <ListItemText primary="Users" />
                                    {this.state.expanded === "user" ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                            }

                            {checkModulePermission('list-users') === true &&
                                <Collapse component="div" in={this.state.expanded === "user"} timeout="auto" unmountOnExit>
                                    <List component="ul" disablePadding>
                                        <ListItem button component="li" className={(this.state.activeClass === "user") ? 'active' : ''}>
                                            <Link to="/users"> <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon>Users</Link>
                                        </ListItem>
                                        {checkModulePermission('add-user') === true &&
                                            <ListItem button component="li" className={(this.state.activeClass === "adduser") ? 'active' : ''}>
                                                <Link to="/user/create"> <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon>Add User</Link>
                                            </ListItem>
                                        }
                                    </List>
                                </Collapse>
                            }
                            {checkModulePermission('list-roles') === true &&
                                <ListItem button component="li" button onClick={this.handleChange(this.state.expanded === "role" ? false : "role")} className={(this.state.activeClass === "role") ? 'active' : ''}>
                                    <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon> <ListItemText primary="Roles" />
                                    {this.state.expanded === "role" ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                            }
                            {checkModulePermission('list-roles') === true &&
                                <Collapse component="div" in={this.state.expanded === "role"} timeout="auto" unmountOnExit>
                                    <List component="ul" disablePadding>
                                        <ListItem button component="li" className={(this.state.activeClass === "role") ? 'active' : ''}>
                                            <Link to="/roles">
                                                <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon> <ListItemText primary="Roles" />
                                            </Link>
                                        </ListItem>
                                        {checkModulePermission('add-role') === true &&
                                            <ListItem button component="li" className={(this.state.activeClass === "addrole") ? 'active' : ''}>
                                                <Link to="/role/add">
                                                    <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon> <ListItemText primary="Add Role" />
                                                </Link>
                                            </ListItem>}
                                    </List>
                                </Collapse>
                            }

                            {checkModulePermission('list-logos') === true &&
                                <ListItem button component="li" className={(this.state.activeClass === "logos") ? 'active' : ''}>
                                    <Link to="/logos">
                                    <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon> <ListItemText primary="	Referrals" />
                                    </Link>
                                </ListItem>
                            }

                            {this.props.authUser.roleId == 1 &&
                                <ListItem button component="li" className={(this.state.activeClass === "transaction") ? 'active' : ''}>
                                    <Link to="/transaction-log">
                                        <ListItemIcon><FontAwesomeIcon icon={["fas", "circle"]} size="xs" color="#bcbccf" /> </ListItemIcon> <ListItemText primary="	Transaction Log" />
                                    </Link>
                                </ListItem>
                            }
                        </>
                    }
                </List>
                {/* <Accordion className={(this.state.activeClass === "userlist") ? 'active' : ''} expanded={this.state.expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                    <AccordionSummary aria-controls="panel1bh-content"
                        id="panel1bh-header" >
                        <Link to="/userlist">User</Link>
                    </AccordionSummary>
                </Accordion>

                <Accordion className={(this.state.activeClass === "deliveries") ? 'active' : ''} expanded={this.state.expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                    <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"

                    >
                        <img src={`${process.env.PUBLIC_URL}/images/shipped-web.png`} className="img-fluid"/>
                        <Link to="/deliveries/0">Deliveries</Link>
                    </AccordionSummary>
                </Accordion>

                <Accordion className={(this.state.activeClass === "salesOrder") ? 'active' : ''} expanded={this.state.expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                    <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <img src={`${process.env.PUBLIC_URL}/images/shopping-cart-web.png`} className="img-fluid"></img>
                        <Link to="/salesorder/0">Orders</Link>
                    </AccordionSummary>
                </Accordion>

                <Accordion className={(this.state.activeClass === "locations") ? 'active' : ''} expanded={this.state.expanded === 'panel6'} onChange={this.handleChange('panel6')}>
                    <AccordionSummary
                        aria-controls="panel3bh-content"
                        id="panel3bh-header"
                    >
                        <img src={`${process.env.PUBLIC_URL}/images/Location-icon-web.png`}
                            className="img-fluid img-location"></img>
                        <Link to="/locations">Locations</Link>
                    </AccordionSummary>
                </Accordion>

                <Accordion className={(this.state.activeClass === "profile") ? 'active' : ''} expanded={this.state.expanded === 'panel4'} onChange={this.handleChange('panel4')}>
                    <AccordionSummary
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <img src={`${process.env.PUBLIC_URL}/images/profile-web.png`} className="img-fluid"></img>
                        <Link to="/profile">Profile</Link>
                    </AccordionSummary>
                </Accordion> */}
            </div>
            </>
        )
    }
}


function mapStateToProps(state) {
    var parsedUserData = state.auth.user;
    var AuthToken = state.auth.authToken;
    return {
        authUser: parsedUserData,
        dashboardData: state.auth.dashboardData,
        loading: state.auth.loading,
        AuthToken: AuthToken
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, auth.actions)(MenuLeftNav);

